import { PopoutableContent, Portal } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { TokenInfo } from "client/Api/Apps/PowerBi/powerBi";
import {
	ReactElement,
	useCallback,
	useState
} from "react";
import { PowerBiEmbed } from "./PowerBiEmbed";
import styles from "./PowerBiPopout.module.less";

export type PowerBiPopoutProps = {
	tileId: number;
	name: string;
	embedUrlBase: string;
	dashboardId: string;
	powerBiTileId: string;
	tokenInfo: TokenInfo;
	onClose: () => void;
};

export const PowerBiPopout = (props: PowerBiPopoutProps): ReactElement => {
	const {
		tileId,
		name,
		embedUrlBase,
		dashboardId,
		powerBiTileId,
		tokenInfo,
		onClose
	} = props;

	const [loadingState, setLoadingState] = useState<LoadingState>({
		isLoading: true
	});

	const errorHandler = useCallback(
		(): void => {
			setLoadingState({
				isLoading: false,
				hasError: true
			});
		},
		[]
	);

	const loadedHandler = useCallback(
		(): void => {
			setLoadingState({
				isLoading: false,
				hasError: false
			});
		},
		[]
	);

	const renderContent = (): ReactElement => {

		if (!loadingState.isLoading && loadingState.hasError) {
			return (
				<p className={styles.errorMessage}>
					{localize("_CouldNotRetrieveTheTileFromPowerBi")}
				</p>
			);
		}

		return (
			<PowerBiEmbed
				embedUrlBase={embedUrlBase}
				dashboardId={dashboardId}
				tileId={powerBiTileId}
				accessToken={tokenInfo.token}
				onError={errorHandler}
				onLoaded={loadedHandler}
				trackingId="embed"
			/>
		);
	};

	return (
		<Portal container={document.body}>
			<PopoutableContent
				isPoppedOut
				onPopin={onClose}
				title={name}
				trackingId={generateTrackingId("powerbi-popout", `|${tileId}`)}
			>
				{renderContent()}
			</PopoutableContent>
		</Portal>
	);
};
PowerBiPopout.displayName = "PowerBiPopout";

type LoadingState =
	{
		isLoading: true;
	}
	|
	{
		isLoading: false;
		hasError: boolean;
	};
